import type { StyledComponent } from '@emotion/styled';
import {
  Box,
  styled,
  CardContent,
  Card,
  Typography,
  CardActions,
} from '@mui/material';

type CardWithButtonProps = {
  cardWithButtonPadding: string;
};

export const StyledPanelImageContainer: StyledComponent<any> = styled(Box)(
  () => ({
    position: 'relative',
    height: '230px',
    width: '100%',
  })
);

export const StyledCard: StyledComponent<any> = styled(Card)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  borderRadius: '8px',
}));

export const StyledHeadingBodyContainer: StyledComponent<any> = styled(Box)(
  () => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  })
);

export const StyledCardContent: StyledComponent<any> = styled(
  CardContent
)<CardWithButtonProps>(({ theme }) => ({
  boxSizing: 'border-box',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2.5),
  paddingTop: 0,
  paddingBottom: 0,
  width: '100%',
  '&.MuiCardContent-root:last-child': {
    padding: theme.spacing(2.5),
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export const StyledTitle: StyledComponent<any> = styled(Typography)(() => ({
  fontSize: '1.125rem',
}));

export const StyledBodyContainer: StyledComponent<any> = styled(Box)(
  ({ theme }) => ({
    flex: 1,
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    fontWeight: theme.typography.fontWeightRegular,
  })
);

export const StyledCardActions = styled(CardActions)<CardWithButtonProps>(
  ({ theme }) => ({
    justifyContent: 'flex-start',
    padding: theme.spacing(2.5),
    paddingTop: 0,
  })
);
